module.exports = __webpack_public_path__ + "static/img/1aab0f06-fd72-4cc4-ae08-38b94bbd7878.13f62728.png";